import { ApplicantCommentsModel } from '@models/comments';
import axiosInstance from '../../utils/http-client';

const getApplicantComments = (id: string): Promise<ApplicantCommentsModel> => {
  return axiosInstance.get(`/api/v1/app/applicants/${id}/comments`, {});
};

export const createComment = (id: string, comment: string): Promise<ApplicantCommentsModel> => {
  return axiosInstance.post(`/api/v1/app/applicants/${id}/comments`, {
    comment,
  });
};

export const editCommentReq = (
  applicantId: string,
  commentId: string,
  comment: string,
): Promise<ApplicantCommentsModel> => {
  return axiosInstance.put(`/api/v1/app/applicants/${applicantId}/comments/${commentId}`, {
    comment,
  });
};

export const deleteCommentReq = (applicantId: string, commentId: string): Promise<ApplicantCommentsModel> => {
  return axiosInstance.delete(`/api/v1/app/applicants/${applicantId}/comments/${commentId}`, {});
};

export default getApplicantComments;
